import { ConfigDataInterface } from './ConfigApiInterface';

export enum Config_MySubsidy_ActionsMenu_ApiEnum {
    'open_hana' = 'open_hana',
}

export enum Config_MySubsidy_Modules_ApiEnum {
    'results' = 'results',
}

export enum Config_MySubsidy_ActionsOther_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_MySubsidy_PageMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_MySubsidy_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_MySubsidy_ApiInterface
    extends ConfigDataInterface<
        Config_MySubsidy_Modules_ApiEnum,
        Config_MySubsidy_ActionsMenu_ApiEnum,
        Config_MySubsidy_ActionsOther_ApiEnum,
        Config_MySubsidy_PageMenu_ApiEnum,
        Config_MySubsidy_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
